import React from 'react';
import { Backdrop } from '@mui/material';
import { LoadingSpinner } from '../LoadingSpinner';

interface SpinnerOverlayProps {
  loading: boolean;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ loading }) => {
  return (
    <Backdrop
      open={loading}
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      aria-hidden="false"
    >
      <LoadingSpinner />
    </Backdrop>
  );
};

export default SpinnerOverlay;
